'use client';

import Sidebar from './Sidebar';
import TopBar from './TopBar';
import Footer from './Footer';

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="flex flex-1">
        <Sidebar />
          <div className="flex-1 flex flex-col min-w-0 dashboard-main-content pt-20">
          <TopBar />
          <main className="flex-1">
            {children}
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
}

